import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { ClientService } from './services/client.service';
import { ClientListComponent } from './client-list/client-list.component';
import { C } from '@angular/cdk/keycodes';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-master',
  templateUrl: './client-master.component.html',
  styleUrls: ['./client-master.component.scss']
})
export class ClientMasterComponent implements OnInit {
  accessRoles: any;

  constructor(
    public sidePanelService:SidePanelService,
    public clientService:ClientService,
    public router:Router
  ) { 
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }


  ngOnInit(): void {
    this.sidePanelService.initSideDrawer('client-master');
  }

  onSearchChange(searchTerm: string): void {
    this.clientService.clientMasterListingSearchChange.emit(searchTerm);
  }

}
